/**
 * View script for bp-grid
 */
